// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  box-sizing: border-box;
}

/* COULEURS POUR LES ETIQUETTES */
:root {
  --blue-color: rgb(0, 23, 93);
  --red-color: rgb(247, 0, 0);
  --grey-color: rgb(115, 115, 115);
}

@font-face {
  font-family: "Blair ITC Std";
  src: url("//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.eot");
  src: url("//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.eot?#iefix")
      format("embedded-opentype"),
    url("//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.woff2")
      format("woff2"),
    url("//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.woff")
      format("woff"),
    url("//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.ttf")
      format("truetype"),
    url("//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.svg#Blair ITC Std")
      format("svg");
}

.fontEtiquette {
  font-family: "Blair ITC Std", serif;
}

/* Message lors de la déconnexion */
.swal-modal {
  font-family: sans-serif;
  border-radius: 15px;
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
.dlpro-block-print{
	
	justify-content: space-evenly;
}
.dlpro-block-print button{
	
	    width: 25%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,0EAA0E;EAC1E;;;;;;;;;mBASiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;CACD,WAAW;EACV;AACF;AACA;;CAEC,6BAA6B;AAC9B;AACA;;KAEK,UAAU;AACf","sourcesContent":["* {\n  margin: 0;\n  box-sizing: border-box;\n}\n\n/* COULEURS POUR LES ETIQUETTES */\n:root {\n  --blue-color: rgb(0, 23, 93);\n  --red-color: rgb(247, 0, 0);\n  --grey-color: rgb(115, 115, 115);\n}\n\n@font-face {\n  font-family: \"Blair ITC Std\";\n  src: url(\"//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.eot\");\n  src: url(\"//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.woff2\")\n      format(\"woff2\"),\n    url(\"//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.woff\")\n      format(\"woff\"),\n    url(\"//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.ttf\")\n      format(\"truetype\"),\n    url(\"//db.onlinewebfonts.com/t/39647bd50f6ae4309c41f87b703e6b70.svg#Blair ITC Std\")\n      format(\"svg\");\n}\n\n.fontEtiquette {\n  font-family: \"Blair ITC Std\", serif;\n}\n\n/* Message lors de la déconnexion */\n.swal-modal {\n  font-family: sans-serif;\n  border-radius: 15px;\n}\n@media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n.dlpro-block-print{\n\t\n\tjustify-content: space-evenly;\n}\n.dlpro-block-print button{\n\t\n\t    width: 25%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
